import "./assets/font-icons/yartu-icons.css";
import "./assets/input.css";
import { createApp } from "vue";
import router from "./router";
import App from "./App.vue";
import YartuUIKit from "@yartu/ui-kit";

createApp(App).use(router).use(YartuUIKit).mount("#app");
